import { CMS } from "./CMS";

export default CMS;
